import React, { FormEventHandler } from 'react';
import Radio from '@mos-cat/radio';
import { t, Trans } from '@lingui/macro';
import cn from 'classnames';

import './PersonGender.pcss';
import { PERSON_FIELD_NAME } from '../../../constants/fieldNames';
import { Field } from '../../../declarations/widget-ums';
import { i18n } from '../../../helpers/i18n';

export type Sex = SEX.MALE | SEX.FEMALE;

export interface SexProps {
  sex: Field<Sex | null>;
  model: string;
  onChange: FormEventHandler;
}

export enum SEX {
  MALE = 'm',
  FEMALE = 'f',
}

function PersonGender<SexComponent>({
  sex,
  onChange,
  model,
}: SexProps): JSX.Element {
  const name = `${model}/${PERSON_FIELD_NAME.sex}`;
  const { value, disabled, error } = sex;

  const classNames = cn('Person__gender', {
    Person__gender_disabled: disabled,
  });
  /* eslint-enable */

  return (
    <div className={classNames}>
      <div className="Person__genderTitle">
        <Trans>Пол:</Trans>
      </div>
      <Radio
        className="ym-hide-content"
        label={i18n._(t`Мужской`)}
        name={name}
        value={SEX.MALE}
        checked={value === SEX.MALE}
        onChange={onChange}
        disabled={disabled}
        error={error}
      />
      <Radio
        className="ym-hide-content"
        label={i18n._(t`Женский`)}
        name={name}
        value={SEX.FEMALE}
        checked={value === SEX.FEMALE}
        onChange={onChange}
        disabled={disabled}
        error={error}
      />
    </div>
  );
}

export default PersonGender;
